'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _CwPodGridColumn = require('./CwPodGridColumn');

var _CwPodGridColumn2 = _interopRequireDefault(_CwPodGridColumn);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var cwPodGridLoader = function cwPodGridLoader(props) {
  // extract required props
  var maxColumns = props.maxColumns,
      children = props.children,
      customLayout = props.customLayout;


  if (customLayout) {
    // Return the custom defined layout
    return children;
  }

  var podColumns = [];

  // By default, add all pods to first column
  podColumns.push(_react2.default.createElement(
    _CwPodGridColumn2.default,
    { key: 0 },
    children
  ));

  // build rest of empty pod columns
  for (var i = 1; i < maxColumns; i++) {
    podColumns.push(_react2.default.createElement(_CwPodGridColumn2.default, { key: i }));
  }

  return podColumns;
};

exports.default = cwPodGridLoader;


//////////////////
// WEBPACK FOOTER
// ./~/cw-ui/lib/components/cwpodgrid/CwPodGridLoader.js
// module id = 850
// module chunks = 10